import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React from 'react';
import { DebugProvider } from 'Context/DebugContext';
import ViewContext, { clientView } from 'Context/ViewContext';
import AppContext from 'Context/AppContext';
import DebugPanel from 'Components/UI/DebugPanel';
import CombinedAppDebugPanel from 'Components/ClientApp/CombinedApp/CombinedAppDebugPanel';
import useAppState from 'Hooks/useAppState';
import { BeaconProvider } from 'Context/BeaconContext';
import ModalRouter from 'Components/Modals/ModalRouter';
import { MobileHeaderProvider } from 'Context/MobileHeaderContext';
import { AnnouncementProvider } from 'Context/AnnouncementContext';
import Content from './Content';

const CombinedApp = () => {
  const { getNotifications, updateNotification, markNotificationsRead } = useSwaggerlessContext();

  const appApiMethods = {
    getNotifications,
    updateNotification,
    markNotificationsRead,
  };

  const appState = useAppState(appApiMethods);
  return (
    <AnnouncementProvider>
      <DebugProvider initialState={null}>
        <ViewContext.Provider value={clientView}>
          <AppContext.Provider value={appState}>{/* TODO: stop using this, use NotificationsListContextProvider instead */}
            <BeaconProvider>{/* TODO: delete Goals and delete this beacon */}
              <MobileHeaderProvider>
                <ModalRouter modalScope="Client" />
                <Content />
                <DebugPanel>
                  <CombinedAppDebugPanel />
                </DebugPanel>
              </MobileHeaderProvider>
            </BeaconProvider>
          </AppContext.Provider>
        </ViewContext.Provider>
      </DebugProvider>
    </AnnouncementProvider>
  );
};


CombinedApp.propTypes = {
};

export default CombinedApp;
